export default {
    'zh_CN': {
        'property.employees.id.label': '主键',
        'property.employees.id.holder': '请输入主键',


        'property.employees.id.required': '主键必填',
        'property.employees.employeesNo.label': '物业员工编号',
        'property.employees.employeesNo.holder': '请输入物业员工编号',
        'property.employees.employeesNo.max': '物业员工编号最多50个字符',

        'property.employees.employeesNo.required': '物业员工编号必填',
        'property.employees.name.label': '姓名',
        'property.employees.name.holder': '请输入姓名',
        'property.employees.name.max': '姓名最多20个字符',

        'property.employees.name.required': '姓名必填',
        'property.employees.pic.label': '照片地址',
        'property.employees.pic.holder': '请输入照片地址',
        'property.employees.pic.max': '照片地址最多255个字符',

        'property.employees.pic.required': '照片地址必填',
        'property.employees.telephone.label': '手机号',
        'property.employees.telephone.holder': '请输入手机号',
        'property.employees.telephone.max': '手机号最多25个字符',

        'property.employees.telephone.required': '手机号必填',
        'property.employees.address.label': '住址',
        'property.employees.address.holder': '请输入住址',
        'property.employees.address.max': '住址最多255个字符',

        'property.employees.address.required': '住址必填',
        'property.employees.jobId.label': '岗位信息id',
        'property.employees.jobName.label': '岗位名称',
        'property.employees.jobId.holder': '请输入岗位信息id',


        'property.employees.jobId.required': '岗位信息id必填',
        'property.employees.createTime.label': '创建时间',
        'property.employees.createTime.holder': '请输入创建时间',
        'property.employees.createTime.required': '创建时间必填',
        'property.employees.updateTime.label': '修改时间',
        'property.employees.updateTime.holder': '请输入修改时间',
        'property.employees.updateTime.required': '修改时间必填',
        'property.employees.isDelete.label': '是否删除',
        'property.employees.isDelete.holder': '请输入是否删除',


        'property.employees.isDelete.dictionary': ()=>[{value:0,label:'删除'}],
        'property.employees.isDelete.required': '是否删除必填'
    },
    'zh_TW': {
        'property.employees.id.label': '主键',
        'property.employees.id.holder': '請輸入主键',


        'property.employees.id.required': '主键必填',
        'property.employees.employeesNo.label': '物业员工编号',
        'property.employees.employeesNo.holder': '請輸入物业员工编号',


        'property.employees.employeesNo.required': '物业员工编号必填',
        'property.employees.name.label': '姓名',
        'property.employees.name.holder': '請輸入姓名',


        'property.employees.name.required': '姓名必填',
        'property.employees.pic.label': '照片地址',
        'property.employees.pic.holder': '請輸入照片地址',


        'property.employees.pic.required': '照片地址必填',
        'property.employees.telephone.label': '手机号',
        'property.employees.telephone.holder': '請輸入手机号',


        'property.employees.telephone.required': '手机号必填',
        'property.employees.address.label': '住址',
        'property.employees.address.holder': '請輸入住址',


        'property.employees.address.required': '住址必填',
        'property.employees.jobId.label': '岗位信息id',
        'property.employees.jobId.holder': '請輸入岗位信息id',


        'property.employees.jobId.required': '岗位信息id必填',
        'property.employees.createTime.label': '创建时间',
        'property.employees.createTime.holder': '請輸入创建时间',


        'property.employees.createTime.required': '创建时间必填',
        'property.employees.updateTime.label': '修改时间',
        'property.employees.updateTime.holder': '請輸入修改时间',


        'property.employees.updateTime.required': '修改时间必填',
        'property.employees.isDelete.label': '是否删除',
        'property.employees.isDelete.holder': '請輸入是否删除',


        'property.employees.isDelete.required': '是否删除必填'
    },
    'en_US': {
        'property.employees.id.label': 'id',
        'property.employees.id.holder': 'Enter id',
        'property.employees.id.max': 'id max length: 主键',


        'property.employees.id.required': 'id required',
        'property.employees.employeesNo.label': 'employeesNo',
        'property.employees.employeesNo.holder': 'Enter employeesNo',
        'property.employees.employeesNo.max': 'employeesNo max length: 物业员工编号',


        'property.employees.employeesNo.required': 'employeesNo required',
        'property.employees.name.label': 'name',
        'property.employees.name.holder': 'Enter name',
        'property.employees.name.max': 'name max length: 姓名',


        'property.employees.name.required': 'name required',
        'property.employees.pic.label': 'pic',
        'property.employees.pic.holder': 'Enter pic',
        'property.employees.pic.max': 'pic max length: 照片地址',


        'property.employees.pic.required': 'pic required',
        'property.employees.telephone.label': 'telephone',
        'property.employees.telephone.holder': 'Enter telephone',
        'property.employees.telephone.max': 'telephone max length: 手机号',


        'property.employees.telephone.required': 'telephone required',
        'property.employees.address.label': 'address',
        'property.employees.address.holder': 'Enter address',
        'property.employees.address.max': 'address max length: 住址',


        'property.employees.address.required': 'address required',
        'property.employees.jobId.label': 'jobId',
        'property.employees.jobId.holder': 'Enter jobId',
        'property.employees.jobId.max': 'jobId max length: 岗位信息id',


        'property.employees.jobId.required': 'jobId required',
        'property.employees.createTime.label': 'createTime',
        'property.employees.createTime.holder': 'Enter createTime',
        'property.employees.createTime.max': 'createTime max length: 创建时间',


        'property.employees.createTime.required': 'createTime required',
        'property.employees.updateTime.label': 'updateTime',
        'property.employees.updateTime.holder': 'Enter updateTime',
        'property.employees.updateTime.max': 'updateTime max length: 修改时间',


        'property.employees.updateTime.required': 'updateTime required',
        'property.employees.isDelete.label': 'isDelete',
        'property.employees.isDelete.holder': 'Enter isDelete',
        'property.employees.isDelete.max': 'isDelete max length: 是否删除',


        'property.employees.isDelete.required': 'isDelete required'
    }
}
